import { render } from "./PaginationContent.vue?vue&type=template&id=7c859301"
import script from "./PaginationContent.vue?vue&type=script&lang=js"
export * from "./PaginationContent.vue?vue&type=script&lang=js"

import "./PaginationContent.vue?vue&type=style&index=0&id=7c859301&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__